"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const SongwriterSummaryCard_1 = __importDefault(require("@Components/Cards/SongwriterSummaryCard"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const SongwriterSummarySection = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { songwriterSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const allSongwriters = songwriterSearchStore.songwriters;
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        songwriterSearchStore.loadSongwriters({}).finally(() => {
            if (songwriterSearchStore.songwriterCount === 1) {
                navigate(navigation_1.default.songwriter.catalog.root(allSongwriters.content[0].id));
            }
            setLoading(false);
        });
    }, []);
    return loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement("section", { className: 'songwriter-summary-section' }, allSongwriters === null || allSongwriters === void 0 ? void 0 : allSongwriters.content.map((item) => (react_1.default.createElement(SongwriterSummaryCard_1.default, Object.assign({ key: item.id }, item))))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterSummarySection);
